export default __webpack_public_path__ + "static/media/service-nail.351c3197.png";